import DecodableLogoSmallUrl from "url:../../../assets/DecodableLogoSmall.svg";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useEffect } from "react";
import { useAgent } from "../../hooks/useAgent";
import { ErrorBoundaryFallbackProps } from "./types";

export function ErrorBoundaryFallback({
  error,
  recordError,
}: ErrorBoundaryFallbackProps) {
  const agent = useAgent();
  useEffect(() => {
    if (error) {
      const shouldReport = recordError?.(error);

      if (shouldReport == undefined || shouldReport == true) {
        agent.recordError("ErrorBoundaryFallback", error);
      }
    }
  }, [error]);

  return (
    <Box
      sx={{ display: "grid", placeItems: "start center", paddingTop: "4rem" }}
    >
      <Box sx={{ display: "grid", gridTemplateColumns: "auto auto" }}>
        <img
          src={DecodableLogoSmallUrl}
          alt=""
          style={{ placeSelf: "center", width: "40px", marginRight: "2ch" }}
        />
        <Box sx={{ borderLeft: "solid 1px rgb(80% 80% 80%)", padding: "2ch" }}>
          <Box component="h1" sx={{ margin: 0 }}>
            Oops!
          </Box>
          <Box component="p">There was a problem processing the request.</Box>
          <Box component="p">
            Try reloading the page, or go back <a href="/">home</a>.
          </Box>
          <Box component="p">
            If the problem persists please reach out to{" "}
            <a href="mailto:support@decodable.co">support</a>.
          </Box>
          <Button
            sx={{ minWidth: "20ch" }}
            variant="contained"
            color="primary"
            onClick={() => document.location.reload()}
          >
            Reload Page
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
